export const routes = (prefix) => [
    {
        path: `/${prefix}/roles`,
        name: `${prefix}.roles.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.roles.index`,
                PageDescription: "Role Listing/Create",
            },
        }
    },
];
